module.exports = __webpack_public_path__ + "img/img38.b295d476.svg";